/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DeleteCustomerProfileResultDtoBase
 * auto generated base class for the model DeleteCustomerProfileResultDtoModel.
 */
export const DeleteCustomerProfileResultDtoModelBase = ModelBase
  .named('DeleteCustomerProfileResultDto')
  .props({
    __typename: types.optional(types.literal("DeleteCustomerProfileResultDto"), "DeleteCustomerProfileResultDto"),
    success: types.union(types.undefined, types.boolean),
    id: types.identifier,
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DeleteCustomerProfileResultDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
  get id() { return this.__attr(`id`) }
}
export function selectFromDeleteCustomerProfileResultDto() {
  return new DeleteCustomerProfileResultDtoModelSelector()
}

export const deleteCustomerProfileResultDtoModelPrimitives = selectFromDeleteCustomerProfileResultDto().success
